import React from 'react';
import {
  View,
  ActivityIndicator,
  StyleSheet,
} from 'react-native';
import { SECONDARY_DARK_COLOR } from '../../../shared/constants/ColorConstants';

export default class LoadingModal extends React.Component {
  render() {
    // alert(StatusBar.currentHeight)
    return (
      this.props.isVisible && (
        <View style={[styles.container, this.props.style]}>
          <View style={styles.modalView}>
            {
              <ActivityIndicator
                color={this.props.loaderColor || SECONDARY_DARK_COLOR}
                size='large'
              />
            }
          </View>
        </View>
      )
    );
  }
}

const styles = StyleSheet.create({
  container: {
    height: '100%',
    backgroundColor: 'transparent',
    zIndex: 400,
    position: 'fixed',
    left: 0,
    right: 0,
    top: '0%',
    //bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',

    // // if we need to hide status bar in android
  },
  modalView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    // left: width / 2,
    // top: height / 3,
    position: 'absolute',
  },
});
